import { environment } from '../../environments/environment'

class DomainAddressesLocal {
    static readonly MAPS_API_DOMAIN = 'http://maps.bs-monolit.test'
    static readonly PUBLIC_MAP_DOMAIN = 'http://bs.local:4300'
}

class DomainAddressesDev {
    static readonly MAPS_API_DOMAIN = 'https://maps.dev.edubears.pl';
    static readonly PUBLIC_MAP_DOMAIN = 'https://maps-public.dev.edubears.pl';
}

class DomainAddressesStage {
    static readonly MAPS_API_DOMAIN = 'https://maps.stage.edubears.pl';
    static readonly PUBLIC_MAP_DOMAIN = 'https://maps-public.stage.edubears.pl';
}

class DomainAddressesProd {
    static readonly MAPS_API_DOMAIN = 'https://maps.bs.edubears.pl'
    static readonly PUBLIC_MAP_DOMAIN = 'https://witrynaeuropa.pl'
}

let temp

switch (environment.name) {
    case 'local':
        temp = DomainAddressesLocal
        break
    case 'development':
        temp = DomainAddressesDev
        break
    case 'stage':
        temp = DomainAddressesStage
        break
    case 'production':
        temp = DomainAddressesProd
        break
}

export const DomainAddresses = temp




// WEBPACK FOOTER //
// /app/src/shared/constants/domain-addresses.ts